import { loginKey } from "./constants";

//returns true the first time it is called for a given storage key within a login session,
//false on every later call until the next login writes a new loginKey timestamp.
//used for notices that are worth showing once but would obstruct the sale line if repeated
export const showOncePerLogin = (storageKey) => {
  //fall back to a sentinel so a missing loginKey doesn't make every call look "already shown"
  const currentLogin = localStorage.getItem(loginKey) || "no-session";
  if (localStorage.getItem(storageKey) === currentLogin) {
    return false;
  }
  localStorage.setItem(storageKey, currentLogin);
  return true;
};

export default showOncePerLogin;
